import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse'

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, DrawSVGPlugin);

import Swiper from 'swiper';
import { Autoplay, EffectFade, Pagination, Navigation } from 'swiper/modules';

import Cookies from 'js-cookie';

// Components

// Global
window.Alpine = Alpine;

// GSAP Configuration
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
window.DrawSVGPlugin = DrawSVGPlugin;

// Swiper
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

window.Swiper = Swiper;
Swiper.use([Autoplay, EffectFade, Pagination, Navigation]);

// Cookies
window.Cookies = Cookies;

// Inits
Alpine.plugin(collapse);
Alpine.start();